var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyfive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currency 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 14.798C31 6.90402 24.2816 0.5 16 0.5C7.71842 0.5 1 6.90402 1 14.798V19.2003H31V14.798Z",
    fill: "url(#paint0_linear_8056_37574)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 4.90229V0.5",
    stroke: "#229E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.70703 11.0058V6.60352",
    stroke: "#229E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.293 11.0058V6.60352",
    stroke: "#229E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.85742 6.1516V1.75684",
    stroke: "#229E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.1426 6.1516V1.75684",
    stroke: "#229E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31 14.798C31 6.90402 24.2816 0.5 16 0.5C7.71842 0.5 1 6.90402 1 14.798V19.2003H31V14.798Z",
    stroke: "#229E4D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16 33.5004C24.2843 33.5004 31 27.0989 31 19.2023C31 11.3058 24.2843 4.9043 16 4.9043C7.71573 4.9043 1 11.3058 1 19.2023C1 27.0989 7.71573 33.5004 16 33.5004Z",
    fill: "#83D043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.6539 17.9059C11.5881 17.9059 10.9486 17.0781 10.9486 16.0622C10.9486 15.0463 11.5881 14.2185 12.6539 14.2185H14.5802V17.9059H17.296V14.2185H23.5644V11.6298H17.296V8.25098H14.5802V11.6298H12.6539C10.0881 11.6298 8.00391 13.6165 8.00391 16.0622C8.00391 18.5079 10.0881 20.4946 12.6539 20.4946H14.5802V17.9059H12.6539ZM19.3565 17.9059H17.296V20.4946H19.3565C20.4223 20.4946 21.0618 21.3224 21.0618 22.3383C21.0618 23.3542 20.4223 24.182 19.3565 24.182H17.296V20.4946H14.5802V24.182H8.34338V26.7707H14.5802V30.1496H17.296V26.7707H19.3565C21.9223 26.7707 24.0065 24.784 24.0065 22.3383C24.0065 19.8926 21.9223 17.9059 19.3565 17.9059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M15.9991 30.2032C22.3737 30.2032 27.5412 25.2774 27.5412 19.2012C27.5412 13.125 22.3737 8.19922 15.9991 8.19922C9.62461 8.19922 4.45703 13.125 4.45703 19.2012C4.45703 25.2774 9.62461 30.2032 15.9991 30.2032Z",
    stroke: "#5ABA3F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.4,
    d: "M29.067 12.1947L10.6644 32.5506C12.3223 33.1526 14.1144 33.4988 15.9933 33.4988C16.4986 33.4988 16.996 33.4762 17.4854 33.4235L30.9539 18.5159C30.8433 16.2207 30.1723 14.076 29.0591 12.1872L29.067 12.1947ZM20.1775 5.47461L2.38281 25.1608C3.21965 26.8991 4.41176 28.4418 5.87229 29.7211L25.4275 8.08588C23.896 6.90441 22.1197 6.0089 20.1775 5.47461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M16 33.5004C24.2843 33.5004 31 27.0989 31 19.2023C31 11.3058 24.2843 4.9043 16 4.9043C7.71573 4.9043 1 11.3058 1 19.2023C1 27.0989 7.71573 33.5004 16 33.5004Z",
    stroke: "#229E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8056_37574",
    x1: 1,
    y1: 9.85393,
    x2: 31,
    y2: 9.85393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77CE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A652"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyfive);
export default __webpack_public_path__ + "static/media/Currencyfive.bacbf1c5a183cfd142eb226c672e703a.svg";
export { ForwardRef as ReactComponent };